require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./mini-urban-retreats.json") })
        }
      }, "path---mini-urban-retreats");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---mini-urban-retreats!./.cache/json/mini-urban-retreats.json
// module id = 320
// module chunks = 231608221292675